import { getApiClient, initializeApiClient } from "../../../apiService";

export const UpdatePalestinianGovernoratesProjectActivities = async (
  tG_PalestinianGovernoratesProjectActivitiesId,
  tG_PalestinianGovernoratesNameId,
  tG_MainTargetedGroupId
) => {
  await initializeApiClient();
  const apiClient = await getApiClient();
  const response = await apiClient.post(
    `/api/TG_PalestinianGovernoratesProjectActivities/UpdateTG_PalestinianGovernoratesProjectActivitiesData`,
    {
      tG_PalestinianGovernoratesProjectActivitiesId:
        tG_PalestinianGovernoratesProjectActivitiesId,
      tG_PalestinianGovernoratesNameId: tG_PalestinianGovernoratesNameId,
      tG_MainTargetedGroupId: tG_MainTargetedGroupId,
    }
  );

  return response;
};

export default UpdatePalestinianGovernoratesProjectActivities;
